import { defaultTo } from 'lodash';
import { IModel, ModelRecord } from '.';

export interface IStoreTypeModel extends IModel {
  storeTypeId: number;
  code: string;
  name: string;
}

export class StoreTypeModel implements ModelRecord<IStoreTypeModel> {
  rowVersion: string;
  storeTypeId: number;
  code: string;
  name: string;

  constructor(params?: Partial<IStoreTypeModel>) {
    this.rowVersion = defaultTo(params?.rowVersion, '');
    this.storeTypeId = defaultTo(params?.storeTypeId, 0);
    this.code = defaultTo(params?.code, '');
    this.name = defaultTo(params?.name, '');
  }
}
